module.exports = __webpack_public_path__ + "img/icon_renzheng.b1516c53.png";